import React, { useId } from "react";
import { Card, Row, Col, Typography, Space, Button } from "antd";
const { Title, Text } = Typography;

interface Stat {
    label: string;
    value: number;
    icon: React.ReactNode;
    color: string;
    extraInfo?: string; // For additional details like +4 or -0
}

interface StatsCardProps {
    title?: string;
    stats: Stat[];
    span?: number
}

const StatsCard: React.FC<StatsCardProps> = ({ stats, title, span }) => {
    const id = useId();
    return (
        <Card title={title} key={id} bordered={false} style={{ width: '100%' }} >
            <Row
                justify="space-between"
                align="middle"
                gutter={[16, 16]}
            >
                {stats.map((stat, index) => (
                    <Col span={span ?? 12} key={index}>
                        <Space direction="vertical" size={"small"}>
                            <Space direction="horizontal" >
                                <Button
                                    shape="circle"
                                    style={{
                                        fontSize: 20,
                                        color: stat.color,
                                        marginRight: 8
                                    }}
                                    icon={stat?.icon}
                                />
                                <Title level={5}>{stat.label}</Title>
                            </Space>
                            <Space direction="horizontal" style={{ marginLeft: 40 }}>
                                <Text>{stat.value}</Text>
                                {stat.extraInfo && (
                                    <Text style={{ color: stat.color }}>
                                        {stat.extraInfo}
                                    </Text>
                                )}
                            </Space>
                        </Space>
                    </Col>

                ))}
            </Row>
        </Card >
    );
};

export default StatsCard;
